<script lang="ts">
	import { EnterOnView } from '$lib/actions/animations/EnterOnView';
	import { createViewController, ViewController } from '$lib/actions/animations/ViewController';
	import Plus from '$lib/icons/Plus.svelte';
	import { Accordion } from '@core/builders/accordion';
	import { gsap } from 'gsap';

	let {
		items,
		multiple = false
	}: { items: { headline: string; description: string }[]; multiple?: boolean } = $props();

	const accordion = Accordion.from<{ headline: string; description: string }>(items, {
		multiple: multiple,
		goIn: (item) => {
			gsap.to(item, { ratio: 1, duration: 0.8, ease: 'expo.inOut' });
		},
		goOut: (item) => {
			gsap.to(item, { ratio: 0, duration: 0.8, ease: 'expo.inOut' });
		}
	});

	createViewController();
</script>

<div class="container" use:ViewController>
	{#each accordion.items as item, i}
		<div class="item" use:EnterOnView={{ delay: 0.1 * i }}>
			<button class="trigger" use:item.useTrigger {...item.attrTrigger}>
				<h3 class="text:description-large">{item.data.headline}</h3>
				<Plus ratio={item.ratio} />
			</button>
			<div use:item.useContent {...item.attrContent}>
				<div class="content">
					<p class="text:description">
						{item.data.description}
					</p>
				</div>
			</div>
		</div>
	{/each}
</div>

<style lang="scss">
	button {
		background: none;
		padding: 0;
		margin: 0;
		border: none;
		cursor: pointer;
	}

	.content {
		padding-top: 20px;
		padding-bottom: 30px;
		max-width: 430px;
	}
	.container {
		display: flex;
		flex-direction: column;
	}

	.item {
		background-color: hsl(var(--color-background));
		display: flex;
		flex-direction: column;
		border-bottom: $border;
	}

	.trigger {
		display: flex;
		padding: 26px 0;
		justify-content: space-between;
		align-items: center;
		text-align: start;
	}
</style>
